<div mat-dialog-content>
    <div class="application-container-button">
        <button mat-icon-button (click)="onClose()">
            <mat-icon>clear</mat-icon>
        </button>
    </div>
    <app-scpStateTypeNew (closeDialog)="onClose()" [stateTypeId]="stateTypeId"></app-scpStateTypeNew>
</div>